import type { ErrorLike } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { type MeQuery, type MeQueryVariables, MeDocument } from 'graphql/generated/graphql';

export type TMe = NonNullable<MeQuery['me']>;

export default function useUser(): [
  MeQuery['me'] | undefined,
  boolean,
  ErrorLike | undefined,
  useQuery.Result<MeQuery, MeQueryVariables>['refetch'],
] {
  const { loading, error, data, refetch } = useQuery(MeDocument);
  return [data?.me, loading, error, refetch];
}
